<template>
  <form-row>
    <label for="ovChipCardNumber-2" class="ordered-counter">
      {{ $t(label) }}
      <tooltip v-if="!isLoggedIn" :title="$t('engraved-id.login-for-available-chipcards')" position="right"/>
    </label>
    <engraved-id-part v-model="engravedId1"
                      :part="1"
                      :disabled="true"
                      :readonly="true"
                      :show-validation-errors="showPartValidationErrors"
                      :parent-error="validation.$error"/>
    <engraved-id-part v-model="engravedId2"
                      :part="2"
                      :validate-on-blur="validateOnBlur && !showCustomerEngravedIdChooser"
                      :show-validation-errors="showPartValidationErrors"
                      :parent-error="validation.$error"
                      @click="onEngravedIdPartClick"/>
    <engraved-id-part v-model="engravedId3"
                      :part="3"
                      :validate-on-blur="validateOnBlur && !showCustomerEngravedIdChooser"
                      :parent-error="validation.$error"
                      :show-validation-errors="showPartValidationErrors"
                      @previous="focusElementIfFound('ovChipCardNumber-2')"
                      @click="onEngravedIdPartClick"/>
    <engraved-id-part v-model="engravedId4"
                      :part="4"
                      :validate-on-blur="validateOnBlur && !showCustomerEngravedIdChooser"
                      :parent-error="validation.$error"
                      :show-validation-errors="showPartValidationErrors"
                      @previous="focusElementIfFound('ovChipCardNumber-3')"
                      @click="onEngravedIdPartClick"/>

    <ul v-if="validation.$error" class="ui-state-error errors" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validation.required">{{ $t('engraved-id.validation.required') }}</li>
      <li v-if="!validation.minLength">{{ $t('engraved-id.validation.required') }}</li>
      <li v-if="!validation.regex">{{ $t('engraved-id.validation.regex') }}</li>
      <li v-if="!validation.errorCode && validation.required && validation.minLength && validation.regex">
        {{ $t(`engraved-id.validation.${validation.$params.errorCode.code}`) }}
      </li>
    </ul>

    <!-- The size of the select element should be at least 2 to make sure the element is rendered as a list -->
    <!-- instead of a 'normal' drop-down select -->
    <select v-if="isLoggedIn && showCustomerEngravedIdChooser && customerEngravedIds.length"
            id="customer-card-engraved-ids"
            :size="customerEngravedIds.length > 1 ? customerEngravedIds.length : 2">
      <option v-for="customerEngravedId in customerEngravedIds"
              :key="customerEngravedId"
              :value="customerEngravedId"
              @click="onEngravedIdOptionClick(customerEngravedId)">{{ customerEngravedId | engravedId }}</option>
    </select>
  </form-row>
</template>

<script>
import EngravedIdPart from './engraved-id/Part'
import FormRow from '../components/FormRow'
import Tooltip from '../../components/Tooltip'
import authenticationMixin from '../../mixins/authentication'
import Vue from 'vue'
import focus from '../../mixins/focus'

export default {
  components: {
    EngravedIdPart,
    FormRow,
    Tooltip
  },
  mixins: [authenticationMixin, focus],
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'engraved-id.label'
    },
    showPartValidationErrors: {
      type: Boolean,
      default: true
    },
    validateOnBlur: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      engravedId1: '3528',
      engravedId2: '',
      engravedId3: '',
      engravedId4: '',
      showCustomerEngravedIdChooser: false,
      customerEngravedIds: []
    }
  },
  watch: {
    value: function () {
      this.splitEngravedId(this.value)
    },
    engravedId2: function (value) {
      if (value.length === 4) this.focusElementIfFound('ovChipCardNumber-3')
      this.updateEngravedId()
    },
    engravedId3: function (value) {
      if (value.length === 4) this.focusElementIfFound('ovChipCardNumber-4')
      this.updateEngravedId()
    },
    engravedId4: function (value) {
      if (value.length === 4) {
        this.showCustomerEngravedIdChooser = false
        this.blurElementIfFound('ovChipCardNumber-4')
      }
      this.updateEngravedId()
    }
  },
  mounted: function () {
    this.splitEngravedId(this.value)
    this.loadCustomerCards()
  },
  methods: {
    async loadCustomerCards () {
      const customerCards = await Vue.$container.userApiClient.getCustomerCards()
      this.customerEngravedIds = customerCards.engravedIdStrings
    },
    updateEngravedId: function () {
      if (this.engravedId2 && this.engravedId3 && this.engravedId4) {
        this.$emit('input', this.engravedId1 + this.engravedId2 + this.engravedId3 + this.engravedId4)
      } else {
        this.$emit('input', this.engravedId1)
      }
    },
    splitEngravedId: function (value) {
      if (value === '') {
        this.engravedId2 = ''
        this.engravedId3 = ''
        this.engravedId4 = ''
      }
      const matches = value.match(/(3528)(\d{4})(\d{4})(\d{4})/)
      if (matches && matches.length === 5) {
        this.engravedId1 = matches[1]
        this.engravedId2 = matches[2]
        this.engravedId3 = matches[3]
        this.engravedId4 = matches[4]
      }
    },
    onEngravedIdPartClick () {
      this.showCustomerEngravedIdChooser = true
    },
    onEngravedIdOptionClick (engravedId) {
      this.splitEngravedId(engravedId)
      this.showCustomerEngravedIdChooser = false
    }
  }
}
</script>

<style scoped>
  #customer-card-engraved-ids {
    margin-top: 5px;
    height: 100px;
    background-image: none;
  }
</style>



// WEBPACK FOOTER //
// src/forms/order-item/EngravedId.vue